import React from 'react';
import { MessageBoxStyleError, MessageBoxStyleSuccess, MessageBoxStyleAlert } from './style';

export function MessageBoxError(props) {
  return (
    <MessageBoxStyleError>
      <div>
        <img src="/images/icons/iconError.svg" alt="Ícone de Erro" />
      </div>
      <p>{props.children}</p>
    </MessageBoxStyleError>
  );
}

export function MessageBoxSuccess(props) {
  return (
    <MessageBoxStyleSuccess>
      <div>
        <img src="/images/icons/iconSuccess.svg" alt="Ícone de Sucesso" />
      </div>
      <p>{props.children}</p>
    </MessageBoxStyleSuccess>
  );
}

export function MessageBoxAlert(props) {
  return (
    <MessageBoxStyleAlert>
      <div>
        <img src="/images/icons/iconAlert.svg" alt="Ícone de Alerta" />
      </div>
      <p>{props.children}</p>
    </MessageBoxStyleAlert>
  );
}
